import * as React from 'react';
import { ActionPointInfo, Controller, CustomArgs, IActionPointInfo, MainMenu, Menu, Toolbar } from '@tencent/workbench';
import { INSERT_TEXT_MENU_CONFIGS, config, titleConfig, TOOLBAR_ITEMS, beautifyConfig, customConfig } from './config';
import { ChangeThemeFeature } from '@framework/workbench/ui/quick-setting/change-theme/change-theme-feature';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class ChangeThemeController {
    public constructor(private readonly feature: ChangeThemeFeature) {
    }


    @Menu(config.id, 'onClick')
    @Toolbar(config.id, 'onClick')
    @Toolbar(beautifyConfig.id, 'onClick', { reportConfig: beautifyConfig })
    @Toolbar(customConfig.id, 'onClick', {
        showCustomTab: true,
        reportConfig: customConfig,
    })
    public onClick(@CustomArgs() args: { showCustomTab: boolean }) {
        this.feature.onClick(args);
    }

    @Menu(titleConfig.id, 'shouldDisabled')
    public titleShouldDisabled() {
        return true;
    }

    @Toolbar(config.id, 'dropdownContent')
    public getPcBtnDropdownContent() {
        return <MainMenu align="left" name={config.id} mode="menu" />;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }
}
